import { Group } from '@mantine/core';
import { GroupLabelProps } from './types';
import {
  groupLabel,
  groupLabelContent,
  groupLabelHoverable,
} from './styles/index.css';
import { lighten } from '@mantine/core';
import useGroupDisplayName from '../hooks/useGroupDisplayName';

export default function GroupLabel({
  group,
  shortName,
  before,
  after,
  hoverable,
  inactive,
  outlined,
  classNames,
  editable,
  onEdit,
  ...props
}: GroupLabelProps) {
  const { getDisplayName } = useGroupDisplayName();
  return (
    <Group
      wrap="nowrap"
      justify={after ? 'space-between' : 'flex-start'}
      {...props}
      style={{
        '--groupColor': group.color,
        '--groupColorLight': lighten(group.color, 0.7),
        ...props.style,
        borderColor: outlined ? undefined : 'transparent',
      }}
      className={`${groupLabel[inactive ? 'inactive' : 'active']} ${hoverable ? groupLabelHoverable : ''} ${classNames?.root || ''} ${props.className || ''}`}
    >
      <Group wrap="nowrap" style={{ gap: 'inherit' }} flex={1} miw={0}>
        {before}
        <Group
          className={`${groupLabelContent} ${classNames?.content || ''}`}
          contentEditable={editable}
          onBlur={(event) => {
            const newValue = event.currentTarget.textContent;
            if (newValue !== null && newValue !== group.name) {
              onEdit?.(newValue);
            }
          }}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              event.currentTarget.blur();
            }
          }}
        >
          {shortName ? group.name : getDisplayName(group)}
        </Group>
      </Group>

      {after}
    </Group>
  );
}
